import { render, staticRenderFns } from "./ShowSection.vue?vue&type=template&id=dc9f259e"
import script from "./ShowSection.vue?vue&type=script&lang=js"
export * from "./ShowSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports